import { Fragment } from "react";

const inline = (s) => s.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
  p.startsWith("**") && p.endsWith("**") ? <strong key={i} className="text-white">{p.slice(2, -2)}</strong> : <Fragment key={i}>{p}</Fragment>);

export const MiniMd = ({ text }) => (
  <div className="space-y-1.5">
    {text.replace(/^#+\s*/gm, "").split("\n").filter((l, i, a) => l.trim() || (i > 0 && a[i - 1].trim())).map((l, i) => {
      const li = l.match(/^\s*(?:[-*•]|(\d+)[.)])\s+(.*)$/);
      if (li) return <div key={i} className="flex gap-2 pl-1"><span className="text-[#3ad7ff] shrink-0">{li[1] ? `${li[1]}.` : "•"}</span><span>{inline(li[2])}</span></div>;
      return l.trim() ? <p key={i}>{inline(l)}</p> : <div key={i} className="h-1" />;
    })}
  </div>
);
